const ResponseStatus = Object.freeze({
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    UI_NETWORK_ERROR: 'UI_NETWORK_ERROR',
});

export default ResponseStatus;
